import React from 'react';
import { useHistory } from 'react-router-dom';
import { connect } from 'react-redux';
import { faSignOut, faLockAlt, faKey } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { withTheme } from '@emotion/react';
import PropTypes from 'prop-types';
import { ParameterWrap, ParameterContent, ParameterFooter, MenuButton } from './styled';
import Button, { BUTTON_SIZES } from '../styled/button';
import { setChangePasswordOverlay } from '../../actions/overlay';
const PageParameter = props => {
  const history = useHistory();
  const handleLogout = event => {
    event.stopPropagation();
    history.push('/logout');
  };
  const handleLogin = event => {
    event.stopPropagation();
    history.push('/login');
  };
  return /*#__PURE__*/React.createElement(ParameterWrap, null, /*#__PURE__*/React.createElement(ParameterContent, {
    onClick: props.onSetPasswordClick
  }, props.accessToken && /*#__PURE__*/React.createElement(MenuButton, null, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    size: "1x",
    icon: faLockAlt,
    color: props.theme.colors.dark
  }), /*#__PURE__*/React.createElement("span", null, "Changer de mot de passe"))), /*#__PURE__*/React.createElement(ParameterFooter, null, props.accessToken && /*#__PURE__*/React.createElement(Button, {
    color: "tertiary",
    onClick: handleLogout,
    size: BUTTON_SIZES.LARGE
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    size: "1x",
    icon: faSignOut,
    color: props.theme.colors.white
  }), "\xA0", /*#__PURE__*/React.createElement("span", null, "D\xE9connexion")), !props.accessToken && /*#__PURE__*/React.createElement(Button, {
    color: "primary",
    onClick: handleLogin,
    size: BUTTON_SIZES.LARGE
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    size: "1x",
    icon: faKey,
    color: props.theme.colors.white
  }), "\xA0", /*#__PURE__*/React.createElement("span", null, "Connexion"))));
};
const mapStateToProps = _ref => {
  let {
    user
  } = _ref;
  return {
    accessToken: user.accessToken
  };
};
const mapDispatchToProps = dispatch => ({
  onSetPasswordClick: event => {
    event.stopPropagation();
    return dispatch(setChangePasswordOverlay());
  }
});
PageParameter.propTypes = {
  accessToken: PropTypes.string,
  onSetPasswordClick: PropTypes.func.isRequired
};
export default connect(mapStateToProps, mapDispatchToProps)(withTheme(PageParameter));